import type { ElementCategory } from "../deviceCategories";
import type { SwitchingRole, SwitchingRoleOf } from "./types";

// An EMA Bewegungsmelder, a Jalousietaster or a switched socket is not a light switch.
const NOT_LIGHTING: ElementCategory[] = [
  "emergencyLighting",
  "fireAlarm",
  "intruderAlarm",
  "sockets",
  "data",
];

const SWITCH = /schalter|taster/i;

const RULES: Array<[(name: string) => boolean, SwitchingRole]> = [
  [(name) => /wechsel|kreuz/i.test(name) && SWITCH.test(name), "twoWay"],
  [(name) => /schalter|taster|dimmer|bewegungsmelder|pr[äa]senzmelder/i.test(name), "control"],
  [(name) => /lichtband/i.test(name), "lichtband"],
  [(name) => /leuchte|downlight|strahler|lampe/i.test(name), "luminaire"],
  [(name) => /l[üu]fter|ventilator/i.test(name), "switchedLoad"],
];

const CONTROLS: SwitchingRole[] = ["control", "twoWay"];

export const switchingRoleOf: SwitchingRoleOf = ({ deviceType, name }) => {
  if (deviceType && NOT_LIGHTING.includes(deviceType.category)) return null;
  const label = deviceType?.name ?? name ?? "";
  const role = RULES.find(([matches]) => matches(label))?.[1] ?? null;
  // A Jalousie- or Türtaster drives a building service, never the light.
  if (role && CONTROLS.includes(role) && deviceType?.category === "buildingServices") return null;
  return role;
};
